import script from "./UploaderTable2.vue?vue&type=script&setup=true&lang=js"
export * from "./UploaderTable2.vue?vue&type=script&setup=true&lang=js"

import "./UploaderTable2.vue?vue&type=style&index=0&id=54532d30&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54532d30"]])

export default __exports__